import "@ha/util/common";

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { TranslocoModule } from "@ngneat/transloco";

import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { ComboboxComponent } from "./components/combobox/combobox.component";
import { InputRadioGroupComponent } from "./components/input-radio-group/input-radio-group.component";
import { InputComponent } from "./components/input/input.component";
import { SearchBoxComponent } from "./components/search-box/search-box.component";
import { SelectComponent } from "./components/select/select.component";
import { SelectOverlayComponent } from "./components/select-overlay/select-overlay.component";
import { ValidationMessagesComponent } from "./components/validation-messages/validation-messages.component";
import { PortalModule } from "@angular/cdk/portal";
import { OverlayModule } from "@angular/cdk/overlay";

export { CheckboxComponent } from "./components/checkbox/checkbox.component";
export { ComboboxComponent } from "./components/combobox/combobox.component";
export { InputRadioGroupComponent } from "./components/input-radio-group/input-radio-group.component";
export { InputComponent } from "./components/input/input.component";
export { SearchBoxAutocompleteListItem } from "./components/search-box/search-box-autocomplete.model";
export { SearchBoxComponent } from "./components/search-box/search-box.component";
export { SelectComponent } from "./components/select/select.component";
export { SelectOverlayComponent } from "./components/select-overlay/select-overlay.component";
export { ValidationMessagesComponent } from "./components/validation-messages/validation-messages.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslocoModule,
        MatDatepickerModule,
        MatNativeDateModule,
        OverlayModule,
        PortalModule,
    ],
    declarations: [
        CheckboxComponent,
        ComboboxComponent,
        InputRadioGroupComponent,
        InputComponent,
        SearchBoxComponent,
        SelectComponent,
        SelectOverlayComponent,      
        ValidationMessagesComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxComponent,
        ComboboxComponent,
        InputRadioGroupComponent,
        InputComponent,
        SelectComponent,     
        SelectOverlayComponent,
        SearchBoxComponent,
        ValidationMessagesComponent,
    ],
})
export class HaUiFormsModule {}
